import { Type } from "class-transformer";
import { IsDate, ValidateNested, IsArray } from "class-validator";
import { TransmedReceivingDetailWithProblems } from "../receivingDetail";
import { InputEntity } from "../../..";

export default class TransmedDistribution {
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => TransmedReceivingDetailWithProblems)
  public readonly receivings!: TransmedReceivingDetailWithProblems[];

  @Type(() => Date)
  @IsDate()
  public readonly start!: Date;
}

export class TransmedDistributionConfirmInput extends InputEntity {
  public constructor(
    public readonly confirmed_lc: string,
    public readonly confirmed_lc_accomodation: boolean
  ) {
    super();
  }
}
